// icons/SendIcon.tsx
import React from "react";

const SendIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0"
        {...props}
    >
        <path
            d="M14.8892 10.6898H4.51953C4.32554 10.6898 4.16315 10.6243 4.03236 10.4934C3.90141 10.3626 3.83594 10.2002 3.83594 10.0062C3.83594 9.81223 3.90141 9.64984 4.03236 9.51904C4.16315 9.3881 4.32554 9.32262 4.51953 9.32262H14.8892L10.1776 4.61107C10.0421 4.47556 9.97522 4.31697 9.97689 4.13529C9.97871 3.9536 10.0503 3.79205 10.1915 3.65062C10.333 3.51861 10.4931 3.45025 10.6719 3.44554C10.8507 3.44083 11.0108 3.50919 11.1522 3.65062L16.9311 9.42949C17.0165 9.51486 17.0766 9.60487 17.1116 9.69951C17.1466 9.79415 17.1642 9.89639 17.1642 10.0062C17.1642 10.116 17.1466 10.2183 17.1116 10.3129C17.0766 10.4076 17.0165 10.4976 16.9311 10.5829L11.1522 16.3618C11.026 16.4881 10.8697 16.5526 10.6833 16.5555C10.4969 16.5584 10.333 16.4938 10.1915 16.3618C10.0503 16.2204 9.97962 16.058 9.97962 15.8746C9.97962 15.6911 10.0503 15.5287 10.1915 15.3872L14.8892 10.6898Z"
            fill="white"
        />
    </svg>
);

export default SendIcon;
